const getHexFromRgb = (rgba) =>
	rgba
		.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+\.{0,1}\d*))?\)$/)
		?.slice(1)
		.map((n, i) =>
			(i === 3 ? Math.round(parseFloat(n) * 255) : parseFloat(n))
				.toString(16)
				.padStart(2, '0')
				.replace('NaN', '')
		)
		.join('');

export const getHexBackgroundColor = (element) => {
	// This will always adhere to rgb/rgba format
	// We need the above function to parse it to hex
	const { backgroundColor = '' } =
		element instanceof Element ? window.getComputedStyle(element) : {};

	const hexValue =
		typeof backgroundColor === 'string'
			? getHexFromRgb(backgroundColor)
			: '';

	return typeof hexValue !== 'undefined' ? `#${hexValue.slice(0, 6)}` : '';
};
